import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppLogo } from "../../components/app-logo";
import { useQueryString } from "../../../../hooks/use-query-string";
import { sendEvents } from "../../actions/audio";
import { isAdaApp } from "../../../../utils/white-label";

export function RejoinPage() {
    const { t } = useTranslation();
    const query = useQueryString();
    const meetingId = query.get("meeting_id");

    useEffect(() => {
        sendEvents();
    }, []);

    return (
        <div className="h-screen bg-white">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-8 offset-md-2">
                        <div
                            className={
                                isAdaApp() ? "text-center" : "text-center m-4"
                            }
                        >
                            <a href="/">
                                <AppLogo />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2 p-3 text-center">
                        <h4>{t("meeting.ended_msg")}</h4>
                        <h5>
                            {meetingId && (
                                <a href={`/meet/${meetingId}`}>
                                    {t("meeting.rejoin")}
                                </a>
                            )}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
}
